import axios from 'axios'
import { Toast } from 'vant';
import baseUrl from '@/utils/baseUrl'
// import router from '@/router'
axios.defaults.timeout = 10000
axios.defaults.baseURL = baseUrl
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// let loadingInstance
axios.interceptors.request.use(
  config => {
    // element ui Loading方法
    // loadingInstance = Loading.service({ fullscreen: true })
    return config
  },
  error => {
    // loadingInstance.close()
    Toast.fail('加载超时')
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  data => {
    const code = data.data.code
    const msg = data.data.msg
    if (['001001', '001004', '001007'].indexOf(code) > -1) {
      Toast.fail(msg)
      window.localStorage.clear()
      // router.push({path: '/'})
    }
    if (['001002', '001006'].indexOf(code) > -1) {
      window.localStorage.clear()
      // router.push({path: '/'})
    }
    // loadingInstance.close()
    return data
  },
  error => {
    // loadingInstance.close()
    // window.localStorage.clear()
    // console.log(error)
    Toast.fail({
      message: '加载失败'
    })

    // if(window.webkit){
    //   window.webkit.messageHandlers.login.postMessage(null)
    //   window.webkit.messageHandlers.back.postMessage(null) 
      
    // }
    // if(window.Android){
    //   window.Android.login()
    //   // window.Android.rollbackWebView()
    // }
    console.log(error)
    return Promise.reject(error)
  }
)

export default axios
